import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=2e85727e&scoped=true"
import script from "./LoginNew.vue?vue&type=script&lang=js"
export * from "./LoginNew.vue?vue&type=script&lang=js"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=2e85727e&prod&scoped=true&lang=css"
import style1 from "./LoginNew.vue?vue&type=style&index=1&id=2e85727e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85727e",
  null
  
)

export default component.exports